import {RouteProps} from 'config/navigation';

import Logs from './logs';
import EditLog from './edit-log';
import {FaFileAlt} from 'react-icons/fa';

const logsPages: RouteProps = {
  name: 'Logs',
  path: 'logs',
  permission: 'logs.findAll',
  icon: <FaFileAlt />,
  subRoutes: [
    {
      path: '',
      element: <Logs />,
      permissions: ['logs.findAll'],
    },
    {
      path: ':id',
      element: <EditLog />,
      permissions: ['logs.findOne'],
    },
  ],
};

export default logsPages;
